import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const FIREBASE_CONFIG = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || 'AIzaSyA6gvGCdI58U0SRHGebeQYEMZeOJvrCfBE',
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || 'eataaa.firebaseapp.com',
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || 'eataaa',
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || 'eataaa.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '331875100669',
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || '1:331875100669:web:0bebfdca910e6159ad9b94',
};

// Inicializa uma única vez (hot reload safe)
const app  = getApps().length === 0 ? initializeApp(FIREBASE_CONFIG) : getApps()[0];
const auth = getAuth(app);

export { app, auth };
